import React from "react";
import styles from "../BrandOfTheMonthModal.module.scss";
import Spinner from "../../../../utils/loader/Spinner";
import {useForm} from "react-hook-form";
import {useCustomerContext} from "../../../../customer/CustomerContextProvider/CustomerContextProvider";
import {useTranslation} from "react-i18next";
import {emailRegExp} from "../../../../lib/ModalWindow/ForgotPasswordModal";
import loginFormStyles from "./LoginForm.module.scss";

type LoginFormState = {
  email: string;
  password: string;
};

const LoginForm: React.FC<{onLoggedIn: (success: boolean) => void}> = ({onLoggedIn}) => {
  const {customer} = useCustomerContext();
  const {t} = useTranslation(["checkout", "customerAccount"]);
  const {
    formState: {errors, isSubmitting},
    register,
    handleSubmit,
  } = useForm<LoginFormState>({mode: "onSubmit", defaultValues: {email: customer.email ?? ""}});

  const onSubmit = (data: LoginFormState) => {
    const {email, password} = data;
    if (Object.keys(errors).length !== 0) {
      return;
    }

    return customer.logIn({username: email, password}).then((success) => {
      onLoggedIn(success);
    });
  };

  return (
    <form className={`${styles.bomForm} ${loginFormStyles.loginForm}`} noValidate onSubmit={handleSubmit(onSubmit)}>
      <div className={loginFormStyles.inputWrapper}>
        <input
          type="email"
          placeholder={t("Ihre E-Mail-Adresse")}
          className={errors.email ? styles.invalid : ""}
          {...register("email", {
            required: t<string>("Bitte ausfüllen"),
            pattern: {value: emailRegExp, message: t<string>("Bitte geben Sie eine gültige E-Mail-Adresse an")},
          })}
        />
        {errors.email && <span className={styles.errorMessageInput}>{errors.email.message}</span>}
      </div>

      <div className={loginFormStyles.inputWrapper}>
        <input
          type="password"
          placeholder={t("Ihr Passwort")}
          className={errors.password ? styles.invalid : ""}
          {...register("password", {required: t<string>("Bitte ausfüllen")})}
        />
        {errors.password && <span className={styles.errorMessageInput}>{errors.password.message}</span>}
      </div>

      <button type="submit" className="grow">
        {isSubmitting ? <Spinner /> : <>{"Einloggen"}</>}
      </button>
    </form>
  );
};

export default LoginForm;
